module.exports = __webpack_public_path__ + "static/will-smith-e66cd4b1f10c5b47881cbc1a29bb8a2a.jpg";